'use client';

import type { TokenInfo } from '@shared/helpers/web3/erc20';

import { useRewardPoolSelfEntries } from '@query/rewardPools';

import type { RewardPool } from '@api/types/rewardPools';

import { ViewTicketsButton } from '../../buttons/ViewTicketsButton/ViewTicketsButton';
import { ListItem } from '../../List/ListItem';
import type { ActionsListProps } from '../types';
import { getTokenNameTitle } from './getTokenNameTitle';
import { SwapButton } from './SwapButton';
import { SwapTypeContinuousMap } from './swapTypeLabelMap';
import { useTokenInfoByRewardPoolSettings } from './useTokenInfoByRewardPoolSettings';

const getLabel = (rewardPool: RewardPool, tokenInfo?: TokenInfo): string => {
  if (!rewardPool.distribution_settings) {
    return '';
  }

  const { distribution_settings } = rewardPool;
  const swapTypeLabel = SwapTypeContinuousMap[distribution_settings.swap_type];
  const tokenNameLabel = getTokenNameTitle(distribution_settings, tokenInfo);

  return `Get Raffle Tickets When ${swapTypeLabel} ${tokenNameLabel} Using Swap`;
};

export const RaffleSwapActionsList = ({ rewardPool, locked }: ActionsListProps) => {
  const { tokenInfo, isTokenLoading } = useTokenInfoByRewardPoolSettings(rewardPool);
  const label = getLabel(rewardPool, tokenInfo);
  const { data: entries = [] } = useRewardPoolSelfEntries(rewardPool.id);

  const { distribution_settings } = rewardPool;

  if (!distribution_settings) {
    return null;
  }

  const { swap_entry_price } = distribution_settings;

  return (
    <ListItem
      key={rewardPool.id}
      isLoading={isTokenLoading}
      data-qa={`swap_action_${rewardPool.id}`}
      isDisabled={locked}
      label={label}
      description={`You will receive 1 ticket for every $${swap_entry_price} of swap volume, increasing your chances to win!`}
      counter={entries.length}
      buttons={
        <>
          <ViewTicketsButton
            invisible={entries.length === 0}
            dataQaAttribute="view-my-tickets-button"
            rewardPool={rewardPool}
          >
            View Tickets
          </ViewTicketsButton>
          <SwapButton rewardPool={rewardPool} locked={locked} isLoading={isTokenLoading} />
        </>
      }
    />
  );
};
